// How-to videos for the Go-Live checklist steps.
//
// Keyed by the ?howto=<key> query param the checklist appends when it navigates.
// The global <HowToVideoModal/> (mounted in Layout) reads that param, looks the
// step up here, and pops the video over whatever page the click landed on.
//
// To publish a video: drop its URL into `videoUrl`. Auto-detected by the modal:
//   • YouTube / Vimeo link
//   • direct video file (.mp4, .webm, ...)
//   • a self-contained .html player — put the file in public/ and point at it,
//     e.g. videoUrl: '/howto/leads.html'. It runs offline in the iframe with its
//     own autoplay + scrub controls.
// Leave it '' to show the "coming soon" placeholder — the popup still appears
// with the title + blurb, just no player.
export const HOW_TO_VIDEOS = {
  company: {
    title: 'Set up your company profile',
    blurb: 'Tell your AI who it represents so every message sounds like you.',
    videoUrl: '/howto/Company_Profile.html',
  },
  knowledge: {
    title: 'Build your knowledge base',
    blurb: 'Download the template, fill it in, then upload it so your AI answers from real facts.',
    videoUrl: '/howto/KnowledgeBase.html',
  },
  leads: {
    title: 'Add your leads',
    blurb: 'Bulk import your contacts from a CSV and let SurFox map the columns for you.',
    videoUrl: '/howto/Bulk_Import_Walkthrough.html',
  },
  availability: {
    title: 'Set your availability',
    blurb: 'Confirm the hours your AI is allowed to book calls into.',
    videoUrl: '/howto/Availability.html',
  },
  campaign: {
    title: 'Launch your campaign',
    blurb: 'Walk through the five setup steps, then flip your campaign on.',
    videoUrl: '/howto/Campaigns.html',
  },
  a2p: {
    title: 'A2P registration',
    blurb: 'How carrier registration works and what happens while it is under review.',
    videoUrl: '',
  },
};
